/* eslint-disable no-restricted-syntax */
import axios from 'axios';
import { httpMethods } from 'enums';
import { IHeaders } from 'types/data.types';
import store from 'Redux/store';
import {
  setLoaderRequest,
  removeErrorRequest,
  removeLoaderRequest,
  removeNotifyRequest,
} from 'Redux/global/global.actions';

import api from 'api/client';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Auth } from '@aws-amplify/auth';
import { clearSessionData } from 'utils';

class Http {
  method: httpMethods;

  url: string;

  token: string;

  access_token: string;

  data: Object;

  cognitoUser: CognitoUser;

  signal?: AbortSignal;

  responseType: any;

  constructor() {
    this.method = httpMethods.post;
    this.url = '';
    this.token = '';
    this.signal = null;
    this.data = {};
  }

  setUrl(url: string) {
    this.url = url;
    return this;
  }

  setData(data: Object) {
    this.data = data;
    return this;
  }

  setCognitoUser(cognitoUser: CognitoUser) {
    this.cognitoUser = cognitoUser;
    return this;
  }

  setSignal(signal: AbortSignal) {
    this.signal = signal;
    return this;
  }

  setResponseType(type: any) {
    this.responseType = type;
    return this;
  }

  // set bearer token header
  setToken(token: string) {
    this.token = `Bearer ${token}`;
    return this;
  }

  // set bearer token header
  setAccessToken(token: string) {
    this.access_token = `Bearer ${token}`;
    return this;
  }

  // set authentication header token
  setTokenHeader(token: string) {
    this.token = token;
    return this;
  }

  setMethod(method: httpMethods) {
    this.method = method;
    return this;
  }

  unsetData() {
    this.data = [];
    this.signal = null;
    return this;
  }

  async request() {
    try {
      store.dispatch(setLoaderRequest());
      store.dispatch(removeErrorRequest());
      store.dispatch(removeNotifyRequest());

      let url = process.env.REACT_APP_URL + this.url;
      if (this.method === httpMethods.get)
        url += this.serializeParams(this.data);

      const headers: any = {
        'Content-Type': 'application/json',
      };

      if (typeof this.token !== undefined) {
        headers.Authorization = this.token;
      }

      if (typeof this.access_token !== undefined) {
        headers['access-token'] = this.access_token;
      }

      const config = {
        url,
        method: this.method,
        signal: this.signal,
        data: JSON.stringify(this.data) || {},
      };

      const instance = axios.create({
        headers: headers,
        responseType: this.responseType,
      });

      instance.interceptors.response.use(
        (res) => {
          return res;
        },
        async (err) => {
          const originalConfig = err.config;

          // const history = useHistory();
          if (originalConfig.url !== '/signin' && err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
              clearSessionData();
              window.location.href = '/signin';
              return;
            }
          }
          throw err;
        }
      );

      const response = await instance(config);

      this.unsetData();

      store.dispatch(removeLoaderRequest());

      return response;
    } catch ({ response }) {
      this.unsetData();
      store.dispatch(removeLoaderRequest());

      // return response;
      throw response;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private serializeParams(params: any) {
    if (typeof params === undefined || Object.keys(params).length <= 0)
      return '';

    let queryString = '';
    // eslint-disable-next-line guard-for-in
    for (const key in params) {
      if (queryString !== '') queryString += '&';
      queryString += `${key}'='${encodeURIComponent(params[key])}`;
    }
    return `?${queryString}`;
  }
}

export default new Http();
